import React from 'react'
import { motion, useAnimation } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import { GiDart } from 'react-icons/gi'
import { PiCurrencyDollarSimpleBold } from 'react-icons/pi'
import { GoStarFill } from 'react-icons/go'

const WhyUs = () => {
  const controls = useAnimation()
  const [ref, inView] = useInView()

  React.useEffect(() => {
    if (inView) {
      controls.start('visible')
    } else {
      controls.start('hidden')
    }
  }, [controls, inView])

  const variants = {
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
    hidden: { opacity: 0, scale: 0.8 },
  }

  return (
    <motion.div
      id="about"
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={variants}
      className="min-h-screen flex flex-col space-y-4 bg-gradient-to-b from-[#A3B69F] to-[#000000] p-4 md:p-16 lg:p-4"  // Gradient applied
    >
      {/* Top Section */}
      <div className="flex flex-col items-center text-center py-6">
        <h1 className="text-[56px] font-bold px-0 py-4 text-white leading-tight font-['Inter']"
          style={{
            textShadow: "0px 6px 5px rgba(0, 0, 0, 0.8)", // Adjust values for shadow
          }}>
          We are a better reporting platform
        </h1>
        <div className="text-base text-[20px] font-normal text-white font-['Inter']">
          <p>We stand out as the preferred choice for carbon reporting due to our commitment to </p>
          <p>accuracy, affordability, and user satisfaction. Our platform offers unparalleled </p>
          <p>convenience, reliability, and support, helping companies navigate complex reporting </p>
          <p>requirements with ease.</p>
        </div>
        <div className="my-5"></div>
      </div>

      {/* Mid Section */}
      <div className="flex flex-wrap gap-6 justify-center max-w-full mx-auto relative z-20"
        style={{
          width: "1180px",
          height: "75px",
          gap: "31px",
      }}>
        {/* Accuracy Box */}
        <div className="relative bg-white rounded-lg p-6 text-center flex flex-col items-center shadow-lg w-[279px] h-[259px] transform hover:scale-105 transition duration-300 ease-in-out hover:shadow-xl">
          <div className="flex items-center justify-center gap-4">
            <p className="text-[24px] font-['Inter'] font-semibold">Accuracy</p>
            <img
              src="/Home_Page_Icon_12.png"
              alt="Target"
              className="w-[58px] h-[56px] justify-right"
            />
          </div>
          <p className="text-[16px] font-['Inter'] font-light mt-4">
            Our commitment to precision ensures reliable carbon reporting results.
          </p>
        </div>

        {/* Affordable Box */}
        <div className="relative bg-white rounded-lg p-6 text-center flex flex-col items-center shadow-lg w-[279px] h-[259px] transform hover:scale-105 transition duration-300 ease-in-out hover:shadow-xl">
          <div className="flex items-center justify-center gap-4">
            <p className="text-[24px] font-['Inter'] font-semibold">Affordable</p>
            <img
              src="/Home_Page_Icon_13.png"
              alt="Coin"
              className="w-[64px] h-[61px] justify-right"
            />
          </div>
          <p className="text-[16px] font-['Inter'] font-light mt-4">
            Offering competitive pricing, our platform makes carbon reporting accessible to all.
          </p>
        </div>

        {/* User Satisfaction Box */}
        <div className="relative bg-white rounded-lg p-6 text-center flex flex-col items-center shadow-lg w-[279px] h-[259px] transform hover:scale-105 transition duration-300 ease-in-out hover:shadow-xl">
          <div className="flex items-center justify-center gap-4">
            <p className="text-[24px] font-['Inter'] font-semibold">User Satisfaction</p>
            <img
              src="/Home_Page_Icon_14.1.png"
              alt="Smile"
              className="w-[33.33px] h-[34.17px] justify-right"
            />
            <img
              src="/Home_Page_Icon_14.2.png"
              alt="Like"
              className="w-[24.38px] h-[21.67px] justify-right"
            />
          </div>
          <p className="text-[16px] font-['Inter'] font-light mt-4">
            With a focus on user experience, we prioritize satisfaction in every aspect of our service.
          </p>
        </div>
      </div>


      {/* Bottom Section: Image */}
      <div className="relative">
        {/* Frame Image */}
        <motion.img
          src="/Home_Page_4.png" // Replace with your image path
          alt="Screen"
          whileInView={{ opacity: 1, x: 0 }}
          initial={{ opacity: 0, x: -100 }}
          transition={{ duration: 0.5 }}
          className="hidden lg:block w-full max-w-[1200px] h-auto mx-auto z-0" // Make it responsive
        />
        
        {/* Content Image */}
        <img
          src="/Home_Page_5.png" // Replace with your second image path
          alt="ESG Content"
          className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-[84.2%] max-w-[1000px] h-auto mx-auto opacity-100 z-10" // Slightly smaller for more precision
          style={{ left: '50%', transform: 'translateX(-48.5%)', width: '84.5%' }} // Adjusting width slightly for fine-tuning
        />
      </div>

    </motion.div>
  )
}

export default WhyUs
